export var rasp_version = '1.0.0'
export var rasp_commit_id = 'Unknown'
export var rasp_build_time = 'Unknown'



// WEBPACK FOOTER //
// ./src/util/version.js